export async function resolveUTXOAddress(name) {
    // Not supported on UTXO yet
    return name;
}
//# sourceMappingURL=resolveUTXOAddress.js.map